"use client";
import React, { useState, useEffect } from "react";

const Ticker = () => {
  const [tickerMessages, setTickerMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Smart API URL detection
  const getApiUrl = () => {
    if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
    const hostname = window.location.hostname;
    if (hostname === '18.133.181.177' || hostname.includes('18.133.181.177')) {
      return 'http://18.133.181.177:3001/api';
    }
    return 'http://localhost:3001/api';
  };
  const API_URL = getApiUrl();

  useEffect(() => {
    const fetchTickerMessages = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${API_URL}/ticker/active`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch ticker messages: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.success && Array.isArray(data.data)) {
          setTickerMessages(data.data);
        } else {
          setTickerMessages([]);
        }
      } catch (err) {
        console.error("Error fetching ticker messages:", err);
        setError("Failed to load announcements");
      } finally {
        setIsLoading(false);
      }
    };

    fetchTickerMessages();
    
    // Refresh ticker messages every 5 minutes
    const intervalId = setInterval(fetchTickerMessages, 5 * 60 * 1000);
    
    return () => clearInterval(intervalId);
  }, [API_URL]);

  // If there are no messages or there's an error, don't render the ticker
  if (isLoading || error || tickerMessages.length === 0) {
    return null;
  }

  const styles = {
    tickerContainer: {
      width: "100%",
      backgroundColor: "#555b6e",
      color: "white",
      padding: "8px 0",
      overflow: "hidden",
      position: "relative",
      marginBottom: "0",
      marginTop: "40px",
      borderRadius: "4px",
    },
    tickerContent: {
      display: "flex",
      whiteSpace: "nowrap",
      animation: "ticker 30s linear infinite",
    },
    tickerItem: {
      padding: "0 20px",
      fontSize: "0.95rem",
      fontWeight: "500",
    },
    "@keyframes ticker": {
      "0%": { transform: "translateX(100%)" },
      "100%": { transform: "translateX(-100%)" },
    },
  };

  // Create a style tag for the animation
  const styleTag = `
    @keyframes ticker {
      0% { transform: translateX(100%); }
      100% { transform: translateX(-100%); }
    }
    
    .ticker-content {
      display: flex;
      white-space: nowrap;
      animation: ticker ${Math.max(30, tickerMessages.length * 10.5)}s linear infinite;
    }
  `;

  // Create a repeated array of messages for infinite scrolling effect
  // Repeat the messages 5 times to ensure continuous scrolling
  const repeatedMessages = [];
  for (let i = 0; i < 5; i++) {
    tickerMessages.forEach((message, index) => {
      repeatedMessages.push({
        ...message,
        key: `${message.id || index}-${i}` // Create unique keys for React
      });
    });
  }

  return (
    <>
      <style>{styleTag}</style>
      <div style={styles.tickerContainer}>
        <div className="ticker-content">
          {repeatedMessages.map((message, index) => (
            <span key={message.key} style={styles.tickerItem}>
              {message.message} {" • "}
            </span>
          ))}
        </div>
      </div>
    </>
  );
};

export default Ticker;
